var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Loader, InstantCollapsible } from "sb-resp-ui";
// external components
import * as CMP from "./components";
import * as SCMP from "../../components";
import Debounce from "debounce-decorator";
import { TypeExtends } from "sb-js-extends";
TypeExtends();
var MyPulseBets = /** @class */ (function (_super) {
    __extends(MyPulseBets, _super);
    function MyPulseBets(props) {
        var _this = _super.call(this, props) || this;
        _this.dict = _this.props.dict;
        // setup data provider
        _this.state = {
            dataProvider: _this.props.dataProvider,
            changedResolution: false
        };
        return _this;
    }
    MyPulseBets.prototype.componentDidMount = function () {
        window.addEventListener("resize", this);
    };
    MyPulseBets.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this);
    };
    MyPulseBets.prototype.handleEvent = function (e) {
        this.handleResizeEvent(e);
    };
    MyPulseBets.prototype.handleResizeEvent = function (e) {
        if (e.type === "resize") {
            this.setState(function (prevState) { return ({ changedResolution: !prevState.changedResolution }); });
        }
    };
    MyPulseBets.prototype.getKey = function (pulseBetTypeData) {
        return "eventTypeCollapsible-" + pulseBetTypeData.eventTypeId + "-" + +this.state.changedResolution;
    };
    MyPulseBets.prototype.renderMyPulseBetContainer = function (pulseBetTypeData) {
        return (React.createElement("div", { className: "rj-my-pusle-bets__collapsible-wrap", key: this.getKey(pulseBetTypeData) },
            React.createElement(InstantCollapsible, { trigger: React.createElement(CMP.SortedHeading, { text: pulseBetTypeData.eventTypeName }), content: React.createElement("div", { className: "rj-my-pulse-bets__main-container" }, this.state.dataProvider.getOpenPulseBets(pulseBetTypeData.eventTypeId).map(this.renderOpenPulseBets, this)), initiallyExpanded: true })));
    };
    MyPulseBets.prototype.renderOpenPulseBets = function (myOpenPulseBet) {
        return (React.createElement(CMP.OpenPulseBet, { key: myOpenPulseBet.uniqueKey, viewModel: myOpenPulseBet, winMsg: this.dict.PulseBetMsgWin.format(myOpenPulseBet.formatedGain), goMsg: this.dict.PulseBetMsgGoal, isGameRunning: this.state.dataProvider.isGameRunning, callbacks: {
                complete: this.state.dataProvider.updateWiningsStatusOnComplete.bind(this.state.dataProvider)
            }, calculateState: this.state.dataProvider.reCalculateState.bind(this.state.dataProvider, myOpenPulseBet.purchaseId) }));
    };
    MyPulseBets.prototype.renderLoader = function () {
        return (React.createElement("div", { className: "rj-my-pulse-bets__loader" },
            React.createElement(Loader, null)));
    };
    MyPulseBets.prototype.renderMessage = function () {
        return (React.createElement("div", { className: "rj-my-pulse-bets__no-open-pulse-bets" }, this.dict.NoOpenPulseBets));
    };
    MyPulseBets.prototype.renderAllPulseBets = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(SCMP.Heading, { label: this.dict.MyPulseBets }),
            !this.state.dataProvider.openViewModels.length && (this.state.dataProvider.isAnyBetsAfterSettlement ? this.renderLoader() : this.renderMessage()),
            (this.state.dataProvider.openViewModels.length > 0) &&
                this.state.dataProvider.pulseBetTypes.map(function (data) { return _this.state.dataProvider.hasAnyOpenPulseBets(data.eventTypeId) && _this.renderMyPulseBetContainer(data); })));
    };
    MyPulseBets.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.state.dataProvider.isMyPulseBetActive &&
            this.renderAllPulseBets()));
    };
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], MyPulseBets.prototype, "handleResizeEvent", null);
    MyPulseBets = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], MyPulseBets);
    return MyPulseBets;
}(React.Component));
export { MyPulseBets };
//# sourceMappingURL=MyPulseBets.js.map